import { Stack, Button, Typography } from '@mui/material';

import { Iconify } from 'src/components/iconify';

type ConnectionButtonProps = {
  label: string;
  icon: string;
  onClick: () => void;
  disabled?: boolean;
  isConnected?: boolean;
  successMessage?: string;
  backgroundColor?: string;
  hoverColor?: string;
};

export function ConnectionButton({
  label,
  icon,
  onClick,
  disabled,
  isConnected,
  successMessage,
  backgroundColor = '#1877F2',
  hoverColor = '#166FE5',
}: ConnectionButtonProps) {
  return (
    <Stack direction="row" alignItems="center" spacing={2}>
      <Button
        variant="contained"
        size="large"
        startIcon={<Iconify icon={icon} />}
        onClick={onClick}
        disabled={disabled}
        sx={{
          background: backgroundColor,
          '&:hover': { background: hoverColor },
          minWidth: 200,
        }}
      >
        {label}
      </Button>

      {isConnected && successMessage && (
        <Stack direction="row" alignItems="center" spacing={1} sx={{ color: 'success.main' }}>
          <Iconify icon="eva:checkmark-circle-fill" width={24} />
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            {successMessage}
          </Typography>
        </Stack>
      )}
    </Stack>
  );
}
